import axios from 'axios';

export function fetchCommissions(partnerId) {
    return axios.get(`/commissions?partnerId=${partnerId}`).then((response) => {
        for (var i = 0; i < response.data.length; i++) stringToDate(response.data[i]);

        return response;
    });
}

export function fetchCommissionForPartner(partnerId) {
    return axios.get(`/partners/${partnerId}/commission`).then((response) => {
        stringToDate(response.data);
        return response;
    });
}

export function patchCommission(payload) {
    return axios.patch('/commissions', payload).then((response) => {
        stringToDate(response.data);
        return response;
    });
}

export function postCommission(commission) {
    return axios.post('/commissions', commission).then((response) => {
        stringToDate(response.data);
        return response;
    });
}
export function removeCommission(commissionId) {
    return axios.delete(`/commissions/${commissionId}`);
}

function stringToDate(data) {
    if (!data) return data;

    return (data.startDate = data.startDate ? new Date(data.startDate) : data.startDate);
}
